var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgZoomIn = _a => {
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size || 24,
    height: size || 24,
    viewBox: "0 0 24 24",
    role: props.role,
    "aria-hidden": props['aria-hidden'] || true
  }, props), React.createElement("path", {
    fill: props.color || 'currentColor',
    fillRule: "evenodd",
    d: "M17.6948832,16.6342231 L21.5303301,20.4696699 C21.8232233,20.7625631 21.8232233,21.2374369 21.5303301,21.5303301 C21.2374369,21.8232233 20.7625631,21.8232233 20.4696699,21.5303301 L16.6342231,17.6948832 C15.1119773,18.9772854 13.1462272,19.75 11,19.75 C6.16750844,19.75 2.25,15.8324916 2.25,11 C2.25,6.16750844 6.16750844,2.25 11,2.25 C15.8324916,2.25 19.75,6.16750844 19.75,11 C19.75,13.1462272 18.9772854,15.1119773 17.6948832,16.6342231 L17.6948832,16.6342231 Z M16.2073041,16.044459 C17.4717439,14.7394591 18.25,12.9606153 18.25,11 C18.25,6.99593556 15.0040644,3.75 11,3.75 C6.99593556,3.75 3.75,6.99593556 3.75,11 C3.75,15.0040644 6.99593556,18.25 11,18.25 C12.9606153,18.25 14.7394591,17.4717439 16.044459,16.2073041 C16.0669119,16.1766715 16.0919822,16.1473576 16.1196699,16.1196699 C16.1473576,16.0919822 16.1766715,16.0669119 16.2073041,16.044459 L16.2073041,16.044459 Z M11.75,10.25 L14,10.25 C14.4142136,10.25 14.75,10.5857864 14.75,11 C14.75,11.4142136 14.4142136,11.75 14,11.75 L11.75,11.75 L11.75,14 C11.75,14.4142136 11.4142136,14.75 11,14.75 C10.5857864,14.75 10.25,14.4142136 10.25,14 L10.25,11.75 L8,11.75 C7.58578644,11.75 7.25,11.4142136 7.25,11 C7.25,10.5857864 7.58578644,10.25 8,10.25 L10.25,10.25 L10.25,8 C10.25,7.58578644 10.5857864,7.25 11,7.25 C11.4142136,7.25 11.75,7.58578644 11.75,8 L11.75,10.25 Z"
  }));
};
export default SvgZoomIn;